var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18730_2000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 8H21C13.8203 8 8 13.8203 8 21V123C8 130.18 13.8203 136 21 136H123C130.18 136 136 130.18 136 123V21C136 13.8203 130.18 8 123 8H104M96 8H88H80",
    stroke: "#DEE2E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 35H113.5M26.5 62H97.5M26.5 87.5H107.5M26.5 117.5H107.5",
    stroke: "#DEE2E5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3672 127.936H33.1932C31.4291 127.936 29.999 129.367 29.999 131.133V174.866C29.999 176.633 31.4291 178.064 33.1932 178.064H42.3672C44.1313 178.064 45.5614 176.633 45.5614 174.866V131.133C45.5614 129.367 44.1313 127.936 42.3672 127.936Z",
    fill: "#F8F9F9",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0069 101.9H74.8475C73.0834 101.9 71.6533 103.332 71.6533 105.098V174.881C71.6533 176.647 73.0834 178.079 74.8475 178.079H84.0069C85.771 178.079 87.2011 176.647 87.2011 174.881V105.098C87.2011 103.332 85.771 101.9 84.0069 101.9Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.648 111.873H116.488C114.724 111.873 113.294 113.305 113.294 115.071V174.866C113.294 176.632 114.724 178.064 116.488 178.064H125.648C127.412 178.064 128.842 176.632 128.842 174.866V115.071C128.842 113.305 127.412 111.873 125.648 111.873Z",
    fill: "#F8F9F9",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.303 65.1465H158.143C156.379 65.1465 154.949 66.5782 154.949 68.3443V174.866C154.949 176.632 156.379 178.064 158.143 178.064H167.303C169.067 178.064 170.497 176.632 170.497 174.866V68.3443C170.497 66.5782 169.067 65.1465 167.303 65.1465Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7728 111.873C44.5713 111.873 50.0826 106.355 50.0826 99.5487C50.0826 92.7423 44.5713 87.2246 37.7728 87.2246C30.9742 87.2246 25.4629 92.7423 25.4629 99.5487C25.4629 106.355 30.9742 111.873 37.7728 111.873Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.428 84.6111C86.2266 84.6111 91.7379 79.0934 91.7379 72.287C91.7379 65.4806 86.2266 59.9629 79.428 59.9629C72.6295 59.9629 67.1182 65.4806 67.1182 72.287C67.1182 79.0934 72.6295 84.6111 79.428 84.6111Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.069 96.951C127.867 96.951 133.379 91.4333 133.379 84.6268C133.379 77.8204 127.867 72.3027 121.069 72.3027C114.27 72.3027 108.759 77.8204 108.759 84.6268C108.759 91.4333 114.27 96.951 121.069 96.951Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.724 52.6482C169.522 52.6482 175.034 47.1305 175.034 40.3241C175.034 33.5177 169.522 28 162.724 28C155.925 28 150.414 33.5177 150.414 40.3241C150.414 47.1305 155.925 52.6482 162.724 52.6482Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 178.078H185.083",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0254 92.7162L69.1009 79.0195",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3418 81.2672L61.1375 71.002",
    stroke: "#7EF2F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0957 76.1855L108.758 82.8441",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3447 65.4395L109.429 69.6156",
    stroke: "#7EF2F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.542 75.6757L153.316 48.2969",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.438 64.3283L143.048 42.8926",
    stroke: "#7EF2F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18730_2000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk4);
export default __webpack_public_path__ + "static/media/risk4.24ad6d8b7db4a6d1433c5ea5fc7a96a2.svg";
export { ForwardRef as ReactComponent };